import TProfileEditPassword from './index.vue';

TProfileEditPassword.install = app => {
  app.component(TProfileEditPassword.name, TProfileEditPassword);
};

export default TProfileEditPassword;
